module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-MediumItalic.a2ab7fe4.woff";